import React from 'react';
import { Stack, Text, Box } from '@stitch-fix/mode-react';
import { TripleBlock, type TripleBlockProps } from '../TripleBlock';
export type ReasonsToSignUpProps = Omit<TripleBlockProps, 'blockSize'>;
export const ReasonsToSignUp = ({
  title,
  ...tripleBlockProps
}: ReasonsToSignUpProps) => {
  return <Stack bgColor="mint-95" px={{
    sm: 1,
    lg: 5
  }} pb={{
    sm: 1,
    lg: 5
  }} spacing={0}>
      <Text as="h2" setting="title-large" align="center" my={{
      sm: 1.5,
      lg: 2.5
    }}>
        {title}
      </Text>
      <Box bgColor="white" p={1}>
        <TripleBlock {...tripleBlockProps} blockSize="sm" />
      </Box>
    </Stack>;
};